import React, { useState,  useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ProductFactory from 'factories/Products';
import style from './style.scss';//NOSONAR


let items = [];
const ProductControlsDropdown = ({configQty, showMaxQuantity, decrementQty, incrementQty, oldQty}) => {

    const quantityRef = useRef();
    const [listItems, setlistItems] = useState([]);
    const [filter, setFilter] = useState('');
    const { quantity } = configQty;

    useEffect(() => {
        const items = getItems(configQty, filter)
        setlistItems(items);
    }, [configQty, filter]);

    const getItems = (configQty, filter = '') => {
        if(!configQty) return false;
        let _items = [];
        items = [];
        for(let i = 1; i <= configQty.maxItemsOrigin; i++) {
            let value = ((i) * configQty.unitMultiplier);
            if(configQty.unitMultiplier !== 1) value = value.toFixed(2)
            let quantityUnit = ProductFactory.formatWeight(configQty.measurementUnit, value);
            let _quantity = quantityUnit.split(' ');
        
            let _filter = _getMatch(i, filter);

            if(_filter || !filter) {
                const selected = (parseFloat(quantity) == parseFloat(_quantity[0]));
                items.push(_quantity[0]);
                _items.push(<li className={"product-control-item" + (selected ? ' selected' : '')}  key={i} onClick={(e) => setValue(e, (value) + '')}  >{_quantity[0]} {configQty.measurementUnit ? _quantity[1] : 'un.'} {selected && <i className="jumbo-icon-new-check dropdown-check"></i>}</li>)
            }
            
        }
        
        return _items;
    }
    
    const _getMatch = (index, filter) => {
        let _unid = 0;
        let _filter = false;
        if(configQty.unitMultiplier !== 1 && filter > 100){
            _unid =  Math.ceil((filter / 1000) / configQty.unitMultiplier);

            _filter = index == _unid;
        }else if(configQty.unitMultiplier !== 1) {
            _filter = false;
            _unid =  Math.ceil((filter) / configQty.unitMultiplier);
            _filter = index == _unid;

            if(index == configQty.maxItemsOrigin && _unid > configQty.maxItemsOrigin){
                _filter = true
            }
        }else if(configQty.unitMultiplier === 1) {

            _filter = (index + '').includes(filter) || (index === configQty.maxItemsOrigin && filter > configQty.maxItemsOrigin);
        }

        return _filter
    }

    const setValue = (e, value) => {
        e.preventDefault();
        sendAmount(e, value)

    }

    const sendAmount = (e, value = null) => {
        e.preventDefault();
        let _qtyNumber = 0;
        let qtyNumberInteger = 0;
        let unitMultiplier = configQty.unitMultiplier;
        let newQuantity = value || quantityRef.current.value;
        if(!newQuantity){
            return false;
        }
        newQuantity = parseFloat(newQuantity.replace(/,/, '.'));

        if (configQty.unitMultiplier === 1) {
            if (newQuantity !== oldQty) {
                if (newQuantity === 0 || newQuantity < oldQty) {
                    decrementQty(e, newQuantity);
                } else {
                    incrementQty(e, newQuantity > configQty.maxItemsOrigin ? configQty.maxItemsOrigin : newQuantity);
                }
            }
        } else {
            if (newQuantity < 100) {
                _qtyNumber = newQuantity / unitMultiplier;

                qtyNumberInteger = Math.ceil(_qtyNumber);

                if ((qtyNumberInteger - oldQty) > configQty.maxItems) {
                    qtyNumberInteger = oldQty + configQty.maxItems;
                }

                if (qtyNumberInteger !== oldQty) {
                    if (newQuantity === 0 || newQuantity < oldQty) {
                        decrementQty(e, qtyNumberInteger);
                    } else {
                        incrementQty(e, qtyNumberInteger);
                    }
                }
            } else {
                _qtyNumber = (newQuantity / unitMultiplier) / 1000;
                qtyNumberInteger = Math.ceil(_qtyNumber);
                if (qtyNumberInteger !== oldQty) {
                    if (configQty.maxItems === 0) {
                        decrementQty(e, qtyNumberInteger);
                    } else {
                        incrementQty(e, qtyNumberInteger);
                    }
                }
            }
        }
    }

    const checkEnter = (e) => {
        if (e.keyCode === 13) {
            sendAmount(e) 
        }
    }

    const validaNumbers = (e) =>{

        let key = e.nativeEvent.data;
        let typeKey = e.nativeEvent.inputType;
        
        let newQuantity = quantityRef.current.value;
        
        if ( newQuantity < 0  || (key && key.includes('-')) || newQuantity > 99){
            quantityRef.current.value = quantity;
            newQuantity = quantity
            return false
        }
    
        if (!(key === '1' || key === '2' || key === '3' || key === '4' || key === '5' || key === '6' || key === '7' || key === '8' || key === '9' || key === '0' || key === ','|| key === '.' || typeKey === "deleteContentBackward")){
            return false
        }

        if(!newQuantity) {
            newQuantity = 0;
        }
        newQuantity = typeof newQuantity === 'string' ? parseFloat(newQuantity.replace(/,/, '.')) : newQuantity;

        if(newQuantity > configQty.maxItemsOrigin) showMaxQuantity(true);
        else showMaxQuantity(false);
    
        setFilter(newQuantity);
    }

    return (
        <div className="product-control-dropdown" >
            <div className="product-control-dropdown-content">
                <div className="product-control-dropdown-content-input">
                    <input type="number" ref={quantityRef} className="input-standard" maxLength="5" placeholder="Cantidad" onChange={validaNumbers} onKeyDown={checkEnter} />
                    {quantityRef?.current?.value && <button className="font-icn arrow-up dropdown-input-quantity mobile-click" onClick={sendAmount}></button>}
                </div>
                <ul className="product-control-items">
                    {listItems}
                </ul>
            </div>
            <div className="product-control-arrow"></div>
        </div>     
    )
}

ProductControlsDropdown.propTypes = {
    config: PropTypes.object
};

export default ProductControlsDropdown;
